var _ellipse, _path, _ellipse2, _path2, _ellipse3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlendLightBeans(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1939,
    cy: 12.1031,
    rx: 8.95725,
    ry: 6.56418,
    transform: "rotate(-11 11.1939 12.1031)",
    fill: "#E3C7A5",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16602 13.9175C3.29102 13.1675 5.54102 11.6675 8.16602 11.6675C10.791 11.6675 12.291 13.1675 14.916 12.7925C17.541 12.4175 18.291 11.6675 19.791 10.5425",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.658,
    cy: 12.4687,
    rx: 8.95725,
    ry: 6.56418,
    transform: "rotate(-77.4067 30.658 12.4687)",
    fill: "#E3C7A5",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7086 21.468C28.4716 20.1369 27.9975 17.4746 29.0481 15.069C30.0988 12.6634 32.0738 11.8892 32.7807 9.33351C33.4877 6.77785 33.1006 5.79036 32.67 3.96547",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.3325,
    cy: 28.6945,
    rx: 8.95725,
    ry: 6.56418,
    transform: "rotate(-36.6197 16.3325 28.6945)",
    fill: "#E3C7A5",
    stroke: "#2D2926",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97716 34.2341C9.66726 33.0714 11.0475 30.746 13.4144 29.6109C15.7813 28.4759 17.7824 29.1798 19.9872 27.7067C22.192 26.2335 22.5439 25.2329 23.41 23.5699",
    stroke: "#2D2926",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlendLightBeans);
export default __webpack_public_path__ + "static/media/iconBlendLightBeans.8aaa5a0de9c0208cb767dfb458ae84bb.svg";
export { ForwardRef as ReactComponent };